import { Lightbox } from '@apparel/ui/lightbox';

export { Lightbox };
